import { render, staticRenderFns } from "./CompanyLogos.vue?vue&type=template&id=9a88e62a&"
import script from "./CompanyLogos.vue?vue&type=script&lang=js&"
export * from "./CompanyLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports